import React from 'react';
import { Box, Grid, Paper, Typography, useMediaQuery, useTheme, Button } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { AuthPageStyles } from '../../authentication/styles';
import { supportUrls } from '../../constants/supportUrls';
import { getCookie } from '../../common/utils/cookies';
import { useAppSelector } from '../../redux-store/hook';

const AccessibilityInformationPage = (): JSX.Element => {
  const { userSessionActive } = useAppSelector((state) => state.basicDetails);
  const { isICPEnabled } = useAppSelector((state) => state.headerDetails);
  const classes = AuthPageStyles({ isICPEnabled: isICPEnabled });

  const { t } = useTranslation();
  const history = useHistory();
  const theme = useTheme();
  const lgUp = useMediaQuery(theme.breakpoints.up('lg'));

  const handleHelp = (event: React.SyntheticEvent): void => {
    event.preventDefault();
    const locale = getCookie('locale_player') || 'en_US';
    const language = supportUrls[locale.toLowerCase()] || 'en_US';
    const link = `https://support.shl.com/candidate?l=${language}&c=SHL_Support%3ACandidate_Help&p=&pt=&lg=&cg=`;
    window.open(link, '_blank');
  };

  const closeAccessibility = (event: React.SyntheticEvent): void => {
    event.preventDefault();
    if (userSessionActive) {
      history.goBack();
    } else {
      history.go(-2);
    }
  };

  return (
    <Grid container justify="center" className={classes.container}>
      <Grid item xl={8} lg={10} className={`${classes.grid}`}>
        <Paper elevation={lgUp ? 1 : 0} className={classes.paper}>
          <Box mb={3}>
            <Typography variant="h1">{t('accessibilityAccomodationHeading')}</Typography>
          </Box>

          <Box mb={3}>
            <Typography variant="body1">{t('accessibilityAccomodationPara1')}</Typography>
          </Box>

          <Box mb={3}>
            <Typography variant="body1">{t('accessibilityAccomodationAssessmentAdjustment')}</Typography>
          </Box>

          <Box mb={3}>
            <ul>
              <li>{t('accessibilityAccomodationAssessmentAdjustmentItem1')}</li>
              <li> {t('accessibilityAccomodationAssessmentAdjustmentItem2')} </li>
              <li>{t('accessibilityAccomodationAssessmentAdjustmentItem3')}</li>
              <li> {t('accessibilityAccomodationAssessmentAdjustmentItem4')} </li>
              <li> {t('accessibilityAccomodationAssessmentAdjustmentItem5')} </li>
              <li> {t('accessibilityAccomodationAssessmentAdjustmentItem6')} </li>
              <li>{t('accessibilityAccomodationAssessmentAdjustmentItem7')}</li>
            </ul>
          </Box>
          <Box mb={3}>
            <Typography variant="body1">{t('accessibilityAccomodationPara2')}</Typography>
          </Box>
          <Box mb={3}>
            <Typography variant="body1">{t('accessibilityAccomodationPara3')}</Typography>
          </Box>
          <Box mb={3}>
            <Typography variant="body1">{t('accessibilityAccomodationPara4')}</Typography>
          </Box>

          <Grid container>
            <Grid item xs={12}>
              <Grid container justify="center" spacing={2}>
                <Grid item>
                  <Button variant="outlined" color="secondary" onClick={handleHelp}>
                    {t('visitShlSupport')}
                  </Button>
                </Grid>
                <Grid item>
                  <Button variant="outlined" color="primary" onClick={closeAccessibility}>
                    {t('close')}
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    </Grid>
  );
};

export default AccessibilityInformationPage;
